import AdminProgressReports from "./routes/AdminProgressReports";
import ProgressReportTemplate from "./routes/ProgressReportTemplate";
import CommentTemplates from "./routes/CommentTemplates";
import CheckList from "./routes/Checklist";
import VoiceAndOutputStructure from "./routes/VoiceAndOutputStructure";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "progressreports",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "progress-report" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    AdminProgressReports(store),
    ProgressReportTemplate(store),
    CommentTemplates(store),
    CheckList(store),
    VoiceAndOutputStructure(store),
  ],
});
